export default "__VITE_ASSET___WoDMA1l__"